import React, { useEffect, useState } from "react";
import "./General.scss";

import { RiCoinsFill } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { FaSortAmountDown } from "react-icons/fa";
import { TbDecimal } from "react-icons/tb";
import { HiReceiptTax } from "react-icons/hi";

import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import { Link } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import InputField from "../../../components/InputField/InputField";
import { setTaxRate } from "../../../api/settings";
import { updateTaxRate } from "../../../redux/features/organization-slice";
import { toast } from "react-toastify";

const GeneralSetting = ({ desktopView, setSelectedTab }) => {
  const {
    currency,
  } = useSelector((state) => state.organizationReducer.value);
  const [showDecimalPart, setShowDecimalPart] = useState(false);

  const [openDescimalDialog, setOpenDescimalDialog] = useState(false);

  return (
    <div className="general-setting">
      <div className="list container-wrapper">
        <Link
          to={desktopView ? "#" : ROUTES.currencySettings.path}
          className="item pointer"
          onClick={() => {
            setSelectedTab && setSelectedTab("Change Currency");
          }}
        >
          <div className="left">
            <RiCoinsFill />
            <p>Currency</p>
          </div>
          <FaChevronRight />
        </Link>

        {/* <div className="item">
          <div className="left">
            <TbDecimal />
            <p>Decimal Parts</p>
          </div>
          <ToggleSwitch
            name={""}
            register={() => {}}
            showSVG={false}
            value={showDecimalPart}
            handleChange={(data) => {
              setShowDecimalPart((pre) => !pre);
              setOpenDescimalDialog(true);
            }}
          />
        </div> */}

        {/* <div className="item pointer">
          <div className="left">
            <FaSortAmountDown />
            <p>Checkout product sorting by</p>
          </div>
          <FaChevronRight />
        </div> */}
      </div>

      <DecimalDialog
        open={openDescimalDialog}
        setOpen={setOpenDescimalDialog}
        showDecimalPart={showDecimalPart}
        setShowDecimalPart={setShowDecimalPart}
        currency={currency}
      />

      {(openDescimalDialog) && (
        <div
          className="back"
          onClick={() => {
            setOpenDescimalDialog(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default GeneralSetting;

const DecimalDialog = ({
  open,
  setOpen,
  showDecimalPart,
  setShowDecimalPart,
  currency,
}) => {
  return (
    <div className={`decimal-dialog ${open ? "active" : ""}`}>
      <p className="heading">Decimal Parts</p>

      <span>
        This will change the way prices are shown, ie: {currency}
        {showDecimalPart ? "12.23" : "12"}
      </span>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
            setShowDecimalPart((pre) => !pre);
          }}
          disabled={false}
        />

        <CustomButton
          name={"Ok"}
          color={"primary"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={false}
        />
      </div>
    </div>
  );
};
